if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          this.addSlickAndFancyBox();
          this.initializeSlickSlider();
          weightpopup()
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      if(this.modalContent.querySelector('variant-radios,variant-selects')) this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
     addSlickAndFancyBox() {
  const slickchecking = this.querySelector('.slick-gallery');
 if (!slickchecking) return;
  const container_main = this.querySelector('.quick-add-modal__content-info');

  const slickScript = document.createElement('script');
  slickScript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
  slickScript.type = 'text/javascript';

  slickScript.onload = function() {
    const fancyBoxScript = document.createElement('script');
    fancyBoxScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.min.js';
    fancyBoxScript.type = 'text/javascript';

    container_main.appendChild(fancyBoxScript);
    container_main.appendChild(slickScript);
}
    }
  initializeSlickSlider() {
  const slickList = this.querySelector('.slick-gallery');
 if (!slickList) return;
  $(slickList).slick({
  dots: true,
  infinite: false,
  slidesToShow: 1,
  arrows:false
});

var elements = this.querySelectorAll('div.slick-product-img');

$(elements).on('click', function() {
    console.log("clicked button")
  $.fancybox.open({
    src: $(this).attr('fancy-zoom'),
    buttons: [
      "zoom",
      "fullScreen",
      "close"
    ],
    fullScreen: {
      autoStart: false,
    },
    afterShow: function() {
      // Your afterShow logic here
    }
  });
});
}
  });
}
function weightpopup(){
  const modal = document.getElementById("variantModal");
    const btn = document.getElementById("selectWeightBtn");
    const span = document.querySelector(".close");
    const addToCartBtn = document.querySelector(".product-form__submit");
    const overlay = document.querySelector('.pairs-modal-overlay');
  if(btn){
    function openModal() {
      modal.style.display = "block";
      document.body.classList.add("modal-active");
      overlay.style.display = 'block';
    }
    function closeModal() {
      modal.style.display = "none";
      document.body.classList.remove("modal-active");
      overlay.style.display = 'none';
    }

    btn.onclick = openModal;
    span.onclick = closeModal;

    window.onclick = function(event) {
      if (event.target == overlay || event.target == span) {
        closeModal();
      }
    }

    addToCartBtn.onclick = function() {
      closeModal();
      const quantityInputs = modal.querySelectorAll('.js-pair-qty-input');
      quantityInputs.forEach(form => {
        form.value = 0;
      });
    }

    document.addEventListener('keydown', function(event) {
      // Check if the pressed key is the Escape key
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  }
}